export const VKRoutes = {
  OAUTHRedirect: '/login/vk/oauth'
}